module.exports = __webpack_public_path__ + "a78f49b864c1ccbf419060e4c78ec967.MP3";